import { useState } from 'react';
import { Form, Input, Button, Card, message, Typography } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { API_BASE } from '../../config';

const { Title, Text } = Typography;

const LoginPage = () => {
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      await login(values.username, values.password);
      message.success('Giriş başarılı');
      // Redirect based on role
      const me = await (await fetch(`${API_BASE}/auth/me`, {
        headers: { Authorization: `Bearer ${document.cookie.match(/token=([^;]+)/)?.[1]}` }
      })).json();
      if (me.role === 'restaurant_user' && me.assignedBusinesses?.length > 0) {
        navigate(`/admin/menu/${me.assignedBusinesses[0]}`);
      } else {
        navigate('/admin/slider');
      }
    } catch {
      message.error('Kullanıcı adı veya şifre hatalı');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #1E1659 0%, #2F2386 50%, #4A3BA8 100%)',
    }}>
      <Card style={{ width: 400, borderRadius: 16, boxShadow: '0 16px 48px rgba(0,0,0,0.2)' }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <Title level={3} style={{ margin: 0, color: '#2F2386' }}>Dihiz Admin</Title>
          <Text type="secondary">Yönetim Paneli</Text>
        </div>
        <Form onFinish={onFinish} layout="vertical" size="large">
          <Form.Item name="username" rules={[{ required: true, message: 'Kullanıcı adı gerekli' }]}>
            <Input prefix={<UserOutlined />} placeholder="Kullanıcı Adı" />
          </Form.Item>
          <Form.Item name="password" rules={[{ required: true, message: 'Şifre gerekli' }]}>
            <Input.Password prefix={<LockOutlined />} placeholder="Şifre" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} block
              style={{ background: '#2F2386', height: 44 }}>
              Giriş Yap
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default LoginPage;
